import { render, staticRenderFns } from "./ContactPersonForm.vue?vue&type=template&id=78d58a1c&scoped=true"
import script from "./ContactPersonForm.vue?vue&type=script&lang=ts"
export * from "./ContactPersonForm.vue?vue&type=script&lang=ts"
import style0 from "./ContactPersonForm.vue?vue&type=style&index=0&id=78d58a1c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78d58a1c",
  null
  
)

export default component.exports